import { MenuNode } from './MenuNode';
import { Helper } from './Helper';
import { BaseSensor } from './BaseSensor';
export class Generator {

	public static DiagnoseCodes() {
		let range = (start: number, end: number) => {
			let r = [];
			for (let i = start; i <= end; i++) {
				r.push(i);
			}
			return r;
		}
		console.log("Generator: Generating menues.");
		let ts = MenuNode.getTranslator();
		if (ts === undefined) {
			console.error("Translator-Service not yet defined.");
			return;
		}
		
		let countryCode = MenuNode.getDataIoService()?.getConfiguration().getConfigPrefix().replace('.', '');
		let nodes = new Array<MenuNode>();
		let sc = MenuNode.getDataIoService().getConfiguration().simulatorConfig;
		let hasH2=sc.hasH2();
		let settableDiagnoseCodes = ["000", "001", "002", "006", "017", "018", "020", "026", "027", "028", "031", "043", "045", "052", "058", "062", "070", "071", "072", "073", "074", "075", "076", "077", "078", "084", "085", "088", "093", "094", "096", "126", "128", "129", "145", "146", "147", "158", "159", "160", "161", "162", "163", "164", "168", "170", "171", "172", "173", "174", "175", "186", "187","200","201"];
		if (sc.hasH2()) {
			settableDiagnoseCodes.push("157");
		}else{
			settableDiagnoseCodes.push("156","157");
		}
		let ignoreDiagnoseCodes = ["007", "046", "050", "051", "086", "099", "103", "123", "126", "127", "132", "181"];
		if(hasH2){
			ignoreDiagnoseCodes.push("146");
		}
		let sensorConfigs = {
			'd000': {
				'unit': 'AICI_UNIT_KW',
				'list': ['DELIGHT_DIA_REPLACE_TEXT_AUTO', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd001': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 1,
				'max': 60,
				'gran': 1,
				'cur': 5,
			},
			'd002': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 2,
				'max': 60,
				'gran': 1,
				'cur': 20,
			},
			'd003': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 1,
				'max': 100,
				'gran': 1,
				'cur': 30,
			},
			'd004': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 1,
				'max': 100,
				'gran': 1,
				'cur': 60,
			},
			'd005': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 1,
				'max': 100,
				'gran': 1,
				'cur': 73
			},
			'd006': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 29,
				'max': 65,
				'gran': 1,
				'cur': 60,
			},
			'd007': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 40,
				'max': 65,
				'gran': 1,
				'cur': 60,
			},
			'd008': {
				'unit': '',
				'list': ['DELIGHT_STATUS_ID_008']
			},
			'd009': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'list': ['0°C', 'DELIGHT_STATUS_ID_009']
			},
			'd010': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd011': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd012': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd013': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd015': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 1,
				'cur': 100
			},
			'd016': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd017': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_017_VALUE_0', 'DELIGHT_DIA_CODE_ID_017_VALUE_1']
			},
			'd018': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_018_VALUE_1', 'DELIGHT_DIA_CODE_ID_018_VALUE_3']
			},
			'd020': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 50,
				'max': 65,
				'gran': 1,
				'cur': 65
			},
			'd021': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd022': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd023': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd024': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd025': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd026': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_026_VALUE_2', 'DELIGHT_DIA_CODE_ID_026_VALUE_3', 'DELIGHT_DIA_CODE_ID_026_VALUE_4', 'DELIGHT_DIA_CODE_ID_026_VALUE_5', 'DELIGHT_DIA_CODE_ID_026_VALUE_6', 'DELIGHT_DIA_CODE_ID_026_VALUE_7', 'DELIGHT_DIA_CODE_ID_026_VALUE_8', 'DELIGHT_DIA_CODE_ID_026_VALUE_9', 'DELIGHT_DIA_CODE_ID_026_VALUE_10', 'DELIGHT_DIA_CODE_ID_026_VALUE_1']
			},
			'd027': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_026_VALUE_2', 'DELIGHT_DIA_CODE_ID_026_VALUE_3', 'DELIGHT_DIA_CODE_ID_026_VALUE_4', 'DELIGHT_DIA_CODE_ID_026_VALUE_5', 'DELIGHT_DIA_CODE_ID_026_VALUE_6', 'DELIGHT_DIA_CODE_ID_026_VALUE_7', 'DELIGHT_DIA_CODE_ID_026_VALUE_8', 'DELIGHT_DIA_CODE_ID_026_VALUE_9', 'DELIGHT_DIA_CODE_ID_026_VALUE_10', 'DELIGHT_DIA_CODE_ID_026_VALUE_1']
			},
			'd028': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_026_VALUE_2', 'DELIGHT_DIA_CODE_ID_026_VALUE_3', 'DELIGHT_DIA_CODE_ID_026_VALUE_4', 'DELIGHT_DIA_CODE_ID_026_VALUE_5', 'DELIGHT_DIA_CODE_ID_026_VALUE_6', 'DELIGHT_DIA_CODE_ID_026_VALUE_7', 'DELIGHT_DIA_CODE_ID_026_VALUE_8', 'DELIGHT_DIA_CODE_ID_026_VALUE_9', 'DELIGHT_DIA_CODE_ID_026_VALUE_10', 'DELIGHT_DIA_CODE_ID_026_VALUE_1']
			},
			'd029': {
				'unit': 'STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 660
			},
			'd031': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_031_VALUE_1', 'DELIGHT_DIA_CODE_ID_031_VALUE_2']
			},
			'd033': {
				'unit': 'AICI_UNIT_ROTATIONSPERMINUTE',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 0
			},
			'd034': {
				'unit': 'AICI_UNIT_ROTATIONSPERMINUTE',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 0
			},
			'd035': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_035_VALUE_0', 'DELIGHT_DIA_CODE_ID_035_VALUE_40', 'DELIGHT_DIA_CODE_ID_035_VALUE_100']
			},
			'd036': {
				'unit': 'STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 0
			},
			'd039': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 50,
				'max': 70,
				'gran': 1,
				'cur': 50
			},
			'd040': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 50,
				'max': 70,
				'gran': 1,
				'cur': 50
			},
			'd041': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 50,
				'max': 70,
				'gran': 1,
				'cur': 40
			},
			'd043': {
				'unit': '',
				'min': 0.1,
				'max': 4,
				'gran': 0.1,
				'cur': 1.2
			},
			'd045': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': -20,
				'max': 100,
				'gran': 0.5,
				'cur': -1
			},
			'd047': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': -10,
				'max': 30,
				'gran': 0.5,
				'cur': -1
			},
			'd052': {
				'unit': '',
				'min': 10,
				'max': 188,
				'gran': 1,
				'cur': 130
			},
			'd058': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_058_VALUE_0', 'DELIGHT_DIA_CODE_ID_058_VALUE_1', 'DELIGHT_DIA_CODE_ID_058_VALUE_2', 'DELIGHT_DIA_CODE_ID_058_VALUE_3', 'DELIGHT_DIA_CODE_ID_058_VALUE_4', 'DELIGHT_DIA_CODE_ID_058_VALUE_5']
			},
			'd060': {
				'unit': '',
				'min': 0,
				'max': 70,
				'gran': 1,
				'cur': 0
			},
			'd061': {
				'unit': '',
				'min': 0,
				'max': 70,
				'gran': 1,
				'cur': 0
			},
			'd062': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 0,
				'max': 16,
				'gran': 1,
				'cur': 0
			},
			'd064': {
				'unit': 'AICI_UNIT_SECOND',
				'min': 0,
				'max': 10,
				'gran': 0.1,
				'cur': 0
			},
			'd065': {
				'unit': 'AICI_UNIT_SECOND',
				'min': 0,
				'max': 10,
				'gran': 0.1,
				'cur': 0
			},
			'd066': {
				'unit': 'DELIGHT_DIA_CODE_ID_066',
				'list': ['DELIGHT_DIA_CODE_ID_066_VALUE_0', 'DELIGHT_DIA_CODE_ID_066_VALUE_1']
			},
			'd067': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 60,
				'gran': 1,
				'cur': 0
			},
			'd068': {
				'unit': '',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd069': {
				'unit': '',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd070': {
				'list': ['DELIGHT_DIA_CODE_ID_070_VALUE_0', 'DELIGHT_DIA_CODE_ID_070_VALUE_2'],
				'unit': '',
			},
			'd071': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 40,
				'max': 80,
				'gran': 1,
				'cur': 75
			},
			'd072': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 10,
				'gran': 1,
				'cur': 2
			},
			'd073': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': -15,
				'max': 5,
				'gran': 1,
				'cur': 0
			},
			'd074': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd075': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 20,
				'max': 90,
				'gran': 1,
				'cur': 45
			},
			'd077': {
				'unit': 'AICI_UNIT_KW',
				'list': ['2.7', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20', '21', '22', '23', '24']
			},
			'd078': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 50,
				'max': 80,
				'gran': 1,
				'cur': 75
			},
			'd080': {
				'unit': 'AICI_UNIT_HOUR_LONG',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd081': {
				'unit': 'AICI_UNIT_HOUR_LONG',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd082': {
				'unit': '',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd083': {
				'unit': '',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd084': {
				'unit': 'AICI_UNIT_HOUR_LONG',
				'min': -100,
				'max': 7000,
				'gran': 100,
				'cur': 2400
			},
			'd085': {
				'unit': 'AICI_UNIT_KW',
				'list': hasH2?['4.2', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20']:['2.7', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20', '21', '22', '23', '24']
			},
			'd088': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['DELIGHT_DIA_CODE_ID_088_VALUE_0', 'DELIGHT_DIA_CODE_ID_088_VALUE_1'],
			},
			'd090': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['DELIGHT_DIA_CODE_ID_090_VALUE_1', 'DELIGHT_DIA_CODE_ID_090_VALUE_0'],
			},
			'd091': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['DELIGHT_DIA_CODE_ID_091_VALUE_0', 'DELIGHT_DIA_CODE_ID_091_VALUE_1', 'DELIGHT_DIA_CODE_ID_091_VALUE_2'],
			},
			'd092': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['DELIGHT_DIA_CODE_ID_092_VALUE_0', 'DELIGHT_DIA_CODE_ID_092_VALUE_1', 'DELIGHT_DIA_CODE_ID_092_VALUE_2'],
			},
			'd093': {
				'unit': '',
				'min': 0,
				'max': 300,
				'gran': 1,
				'cur': 161
			},
			'd094': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd095': {
				'list': ['{{tr:DELIGHT_SOFTWARE_VERSION_BMU}} 0376.12.01', '{{tr:DELIGHT_SOFTWARE_VERSION_AI}} 0373.12.01'],
				'unit': ''
			},
			'd096': {
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL'],
				'unit': ''
			},
			'd098': {
				'unit': '',
				'list': ['06.05']
			},
			'd123': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 30,
				'gran': 1,
				'cur': 0
			},
			'd124': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_124_VALUE_0', 'DELIGHT_DIA_CODE_ID_124_VALUE_1'],
			},
			'd125': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 0,
				'max': 30,
				'gran': 1,
				'cur': 0
			},
			'd126': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 30,
				'gran': 1,
				'cur': 0
			},
			'd128': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 30,
				'max': 75,
				'gran': 1,
				'cur': 30
			},
			'd129': {
				'unit': 'STD_UNIT_CELSIUS_NORMAL_LEFT',
				'min': 35,
				'max': 65,
				'gran': 1,
				'cur': 35
			},
			'd145': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd146': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_146_VALUE_0', 'DELIGHT_DIA_CODE_ID_146_VALUE_1']
			},
			'd147': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_147_VALUE_0', 'DELIGHT_DIA_CODE_ID_147_VALUE_1']
			},
			'd156': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_156_VALUE_0', 'DELIGHT_DIA_CODE_ID_156_VALUE_1']
			},
			'd157': {
				'unit': '',
				'list':
					hasH2?[
						'DELIGHT_DIA_CODE_ID_157_VALUE_8'
					]:
					[
						(!hasH2?'DELIGHT_DIA_CODE_ID_157_VALUE_1':'DELIGHT_DIA_CODE_ID_157_VALUE_8'),
						false ? 'DELIGHT_DIA_CODE_ID_157_VALUE_0' : undefined, // Nicht ausgewählt 
						['de', 'ch', 'at'].includes(countryCode) ? undefined : 'DELIGHT_DIA_CODE_ID_157_VALUE_2', // Propan 30/37 mbar
						countryCode == 'fr' ? 'DELIGHT_DIA_CODE_ID_157_VALUE_3' : undefined, // Sondergas FR
						countryCode == 'en' ? 'DELIGHT_DIA_CODE_ID_157_VALUE_4' : undefined, // Sondergas GB
						countryCode == 'it' ? 'DELIGHT_DIA_CODE_ID_157_VALUE_5' : undefined, // Sondergas IT
						['de', 'ch', 'at'].includes(countryCode) ? 'DELIGHT_DIA_CODE_ID_157_VALUE_6' : undefined, // Propan 50 mbar
						countryCode == 'pl' ? 'DELIGHT_DIA_CODE_ID_157_VALUE_7' : undefined, // Ls Gas
						(hasH2?'DELIGHT_DIA_CODE_ID_157_VALUE_1':'DELIGHT_DIA_CODE_ID_157_VALUE_8'), // Wasserstoff
					].filter(
						(x: string | undefined) => x != undefined
					)
			},
			'd158': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_158_VALUE_0', 'DELIGHT_DIA_CODE_ID_158_VALUE_1', 'DELIGHT_DIA_CODE_ID_158_VALUE_2', 'DELIGHT_DIA_CODE_ID_158_VALUE_3', 'DELIGHT_DIA_CODE_ID_158_VALUE_4', 'DELIGHT_DIA_CODE_ID_158_VALUE_5', 'DELIGHT_DIA_CODE_ID_158_VALUE_M1', 'DELIGHT_DIA_CODE_ID_158_VALUE_M2', 'DELIGHT_DIA_CODE_ID_158_VALUE_M3', 'DELIGHT_DIA_CODE_ID_158_VALUE_M4', 'DELIGHT_DIA_CODE_ID_158_VALUE_M5']
			},
			'd159': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd160': {
				'unit': 'STD_UNIT_BAR_NORMAL_LEFT',
				'min': 0,
				'max': 3,
				'gran': 0.1,
				'cur': 1
			},
			'd162': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_162_VALUE_0', 'DELIGHT_DIA_CODE_ID_162_VALUE_1']
			},
			'd163': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_026_VALUE_11', 'DELIGHT_DIA_CODE_ID_026_VALUE_1']
			},
			'd164': {
				'unit': '',
				'min': -5,
				'max': 5,
				'gran': 1,
				'cur': 0
			},
			'd166': {
				'unit': '',
				'list': [hasH2?'0':'DELIGHT_DIA_CODE_ID_166_VALUE_0'],
			},
			'd167': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_167_VALUE_0'],
			},
			'd168': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_168_VALUE_0', 'DELIGHT_DIA_CODE_ID_168_VALUE_1'],
			},
			'd170': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_170_VALUE_0', 'DELIGHT_DIA_CODE_ID_170_VALUE_1', 'DELIGHT_DIA_CODE_ID_170_VALUE_2', 'DELIGHT_DIA_CODE_ID_170_VALUE_3', 'DELIGHT_DIA_CODE_ID_170_VALUE_4', /*'DELIGHT_DIA_CODE_ID_170_VALUE_5', 'DELIGHT_DIA_CODE_ID_170_VALUE_6'*/]
			},
			'd171': {
				'unit': 'AICI_UNIT_MBAR',
				'min': 100,
				'max': 400,
				'gran': 10,
				'cur': 200
			},
			'd172': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 10,
				'max': 20,
				'gran': 1,
				'cur': 20
			},
			'd173': {
				'unit': 'AICI_UNIT_MBAR',
				'min': 100,
				'max': 400,
				'gran': 50,
				'cur': 200
			},
			'd174': {
				'unit': 'AICI_UNIT_MBAR',
				'min': 100,
				'max': 400,
				'gran': 50,
				'cur': 400
			},
			'd175': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 50,
				'max': 100,
				'gran': 10,
				'cur': 100
			},
			'd182': {
				'unit': '',
				'min': 1,
				'max': 255,
				'gran': 10,
				'cur': 100
			},
			'd185': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_185_VALUE_0', 'DELIGHT_DIA_CODE_ID_185_VALUE_1']
			},
			'd186': {
				'unit': '',
				'list': range(0, 5).map(i => `DELIGHT_DIA_CODE_ID_186_VALUE_${i}`)
			},
			'd187': {
				'unit': '', 'list': ['DELIGHT_DIA_CODE_ID_187_VALUE_0', 'DELIGHT_DIA_CODE_ID_187_VALUE_1']
			},

			'd200': {
				'unit': '', 
				'list': ['AICI_NO_NORMAL','AICI_YES_NORMAL']
			},
			'd201': {
				'unit': '', 
				'list': ['DELIGHT_DIA_CODE_ID_201_VALUE_0', 'DELIGHT_DIA_CODE_ID_201_VALUE_1']
			},

			'd9999': {
				'tag': 'Einstellbare Heizbelastung',
				'unit': 'AICI_UNIT_KWH',
				'list': ['3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20', '21', '22', '23', '24']
			},
			'd9998': {
				'tag': 'Restförderhöhe',
				'unit': 'AICI_UNIT_MBAR',
				'min': 100,
				'max': 400,
				'gran': 10,
				'cur': 200
			},
			'd9997': {
				'tag': 'ist das die korrekte gasart?',
				'unit': '',
				'list': ['AICI_YES_NORMAL', 'AICI_NO_NORMAL']
			}
		};
		let configService = MenuNode.getDataIoService().getConfiguration();
		if (configService.getConfigPrefix() == 'de') {
			ignoreDiagnoseCodes.push('162');
		}


		if (sc.getVariant() == 'ecoTEC plus') {
			sensorConfigs.d170.list.shift();
			sensorConfigs.d170.list.shift();
		}
		let di = MenuNode.getDataIoService().getDeviceInfo();
		for (let name of Object.keys(sensorConfigs)) {
			let s: BaseSensor = null;
			let data = sensorConfigs[name];
			if (data['list']) {
				s = new BaseSensor();
				s.setList(data['list']);
				s.setUnit(data['unit']);
				s.setCurrentValue(0);
			} else {
				s = BaseSensor.fromArgs(name, data['cur'], data['min'], data['max'], data['gran'], data['unit']);
			}
			if (name == 'd084') {
				s.setSpecialValue(-100, "DELIGHT_DIA_REPLACE_TEXT_NOT_SET");
			}
			if (name == 'd006') {
				s.setSpecialValue(29, "AICI_OFF_NORMAL", "iconDomesticHotWaterDis")
			}
			if (name == 'd077') {
				s.setCurrentValue(s.getMaxValue());
			}
			if (name == 'd020') {
				s.registerHook('valueChanged',
					(newVal) => {
						let d006 = di.getScale('d006');
						if (d006.getCurrentValue() > newVal) {
							d006.setCurrentValue(newVal);
						}
						d006.setMaxValue(newVal);
					});
			}
			if (name == 'd094') {
				s.registerHook('valueChanged',
					function (newVal) {
						if (newVal == 1) {
							s.setCurrentValue(0);
						}
					}
				);
			}
			if (name == 'd157') {
				s.registerHook('valueChanged', (val) => {
					di.getScale('d156').setCurrentValue(0);
				});
			}
			if (name == 'd186') {
				s.registerHook('valueChanged', (val) => {
					di.getScale('d187').setCurrentValue(0);
				});
			}
			s.setName(name);
			di.setScale(name, s);
		}


		for (let i = 0; i < 202; i++) {

			let id = Helper.threeDigits(i);
			if (ignoreDiagnoseCodes.includes(id)) {
				continue;
			}
			let key: string = "DELIGHT_DIA_CODE_ID_" + id;
			if (!ts.has(key)) {
				continue;
			}

			switch (i) {
				case 161: {

					let d = {
						"title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:servicedate}}",
						"type": "menuentry",
						"id": "diagnoseCode." + id,
						"target": "goto:child:0",
						"children": [
							{
								"name": "timeset_date_diag",
								"title": "EDITOR_SERVICE_DATE_TITLE",
								"text": [
									"EDITOR_SERVICE_DATE_SUBLINE_1"
								],
								"template": "timeset",
								"buttons": "confirm,back,slider,menu",
								"template_parameter": "date,lightTitle,showText,lightText",
								"onConfirm": "set:servicedate",
								"value": "{{get:servicedate.toInt}}",
								"target": "goto:diagnosecode_ladeschirm",
								"back": "goto:diagnosecode_ladeschirm"
							}
						]
					};
					nodes.push(new MenuNode(d));
					continue;
				}
				case 96: {
					let d = {
						"title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|--",
						"__title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:deviceinfo.d096.toString}}",
						"type": "menuentry",
						"back": "goto:previous",
						"id": "diagnoseCode." + id,
						"target": "goto:child:0",
						"template_parameter": "nobox,darkerTitle,loadDelay,inline",
						"buttons": "confirm,slider,back",
						"children": [
							{
								"template": "menu",
								"title": "D.096",
								"subtitle": key,
								"buttons": "confirm,slider,back",
								"template_parameter": "nobox,darkerTitle,loadDelay,inline,subtitleAtBottom,circular,smallValue",
								"children": [
									{
										"type": "menuentry",
										"title": "AICI_NO_NORMAL",
										"target": "goto:diagnosecode_ladeschirm"
									},
									{
										"type": "menuentry",
										"title": "AICI_YES_NORMAL",
										"target": "goto:child:0",
										"children": [
											{
												"name": "WERKSEINSTELLUNGEN",
												"infoId": "24",
												"id": "factory_settings_diag",
												"title": "DELIGHT_DIA_CODE_ID_096",
												"buttons": "confirm,back,menu",
												"template": "toast",
												"icon": "iconWarning",
												"onConfirm": "run:reset",
												"target": "goto:reset_running",
												"text": [
													"SUBMENU_FACTORY_RESET_SUBLINE_1",
													"SUBMENU_FACTORY_RESET_SUBLINE_2",
													"SUBMENU_FACTORY_RESET_SUBLINE_3"
												]
											}
										]
									}
								]
							}

						]
					};
					nodes.push(new MenuNode(d));
					continue;
				}
				case 157: {

					let title = 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:deviceinfo.d" + id + ".toString}}";
					let nodeData = {
						'title': title,
						'type': 'menuentry',
						"id": "diagnoseCode." + id,
						"conditionalTargets": {
							"condition": "{{get:deviceinfo.d156.listEntry}}",
							"DELIGHT_DIA_CODE_ID_156_VALUE_0": "goto:child:0",
							"DELIGHT_DIA_CODE_ID_156_VALUE_1": "goto:child:1"
						}
					}

					let editable: boolean = settableDiagnoseCodes.includes(id);

					let node = new MenuNode(nodeData);
					let childGen = (editable: boolean) => ({
						'title': 'D.' + Helper.threeDigits(i),
						'template': (editable ? 'settingsvalue' : 'showvalue'),
						'text': [key],
						'type': 'temperature',
						'template_parameter': (editable ? 'circular,smallValue' : 'smallValue'),
						'buttons': (editable ? 'back,up,down,confirm' : 'back'),
						'onConfirm': 'set:deviceinfo.d' + id,
						'target': 'goto:diagnosecode_ladeschirm',
						'back': 'goto:diagnosecode_ladeschirm'
					});
					node.addChild(new MenuNode(childGen(false)));
					node.addChild(new MenuNode(childGen(true)));
					nodes.push(node);
					continue;
				}

				case 186: {

					let title = 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:deviceinfo.d" + id + ".toString}}";
					let nodeData = {
						'title': title,
						'type': 'menuentry',
						"id": "diagnoseCode." + id,
						"conditionalTargets": {
							"condition": "{{get:deviceinfo.d187.listEntry}}",
							"DELIGHT_DIA_CODE_ID_187_VALUE_0": "goto:child:0",
							"DELIGHT_DIA_CODE_ID_187_VALUE_1": "goto:child:1"
						}
					}

					let editable: boolean = settableDiagnoseCodes.includes(id);

					let node = new MenuNode(nodeData);
					let childGen = (editable: boolean) => ({
						'title': 'D.' + Helper.threeDigits(i),
						'template': (editable ? 'settingsvalue' : 'showvalue'),
						'text': [key],
						'type': 'temperature',
						'template_parameter': (editable ? 'circular,smallValue' : 'smallValue'),
						'buttons': (editable ? 'back,up,down,confirm' : 'back'),
						'onConfirm': 'set:deviceinfo.d' + id,
						'target': 'goto:diagnosecode_ladeschirm',
						'back': 'goto:diagnosecode_ladeschirm'
					});
					node.addChild(new MenuNode(childGen(false)));
					node.addChild(new MenuNode(childGen(true)));
					nodes.push(node);
					continue;
				}
				default: {

				}
			}


			let title = 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:deviceinfo.d" + id + ".toString}}";
			let nodeData = {
				'title': title,
				'type': 'menuentry',
				"id": "diagnoseCode." + id,
				'target': 'goto:child:0'
			}

			let editable: boolean = settableDiagnoseCodes.includes(id);

			let node = new MenuNode(nodeData);
			let childData = {
				'title': 'D.' + Helper.threeDigits(i),
				'template': (editable ? 'settingsvalue' : 'showvalue'),
				'text': [key],
				'type': 'temperature',
				'template_parameter': (editable ? 'circular,smallValue' : 'smallValue'),
				'buttons': (editable ? 'back,up,down,confirm' : 'back'),
				'onConfirm': 'set:deviceinfo.d' + id,
				'target': 'goto:diagnosecode_ladeschirm',
				'back': 'goto:diagnosecode_ladeschirm'
			}
			if (key == 'DELIGHT_DIA_CODE_ID_095') {
				node.title = 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|--"
				childData['template_parameter'] += ',autoScroll';
				childData['id'] = 'd-child.095'
			}
			node.addChild(new MenuNode(childData));
			nodes.push(node);
		}
		console.log("nodes:");
		console.log(nodes);
		return nodes;
	}












	public static DataOverview() {
		let ts = MenuNode.getTranslator();
		if (ts === undefined) {
			console.error("Translator-Service not yet defined.");
			return;
		}
		let elements = [
		]
		let nodes = new Array<MenuNode>();
		let status = '31';
		let statusCode = Helper.threeDigits(status);
		let translationUnits = [];

		let end = false;
		for (let i = 1; i < 256 && !end; i++) {
			let trId = 'DELIGHT_STATUS_ID_' + statusCode + '_DETAILS_' + i;
			if (ts.has(trId)) {
				translationUnits.push(trId);
			} else {
				end = true;
			}
		}
		let key = "S." + status;
		let value = "";

		for (let trId of translationUnits) {
			value += ts.tr(trId);
			if (trId != translationUnits[translationUnits.length - 1]) {
				value += "\n"
			}
		}

		elements.push(key + '|' + value);
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_WATER_PRESSURE}}|{{get:zone.default.sensor.pressure.water.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_MODULATION}}|{{get:zone.default.sensors.misc.currentModulation.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_TARGETFLOW_TEMP}}|{{get:heatingCircuit.1.vorlaufsolltemp.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_FLOW_TEMP}}|{{get:heatingCircuit.1.vorlaufisttemp.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_RETURN_TEMP}}|{{get:deviceinfo.d041.toString}}')
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_DHW_SETPOINT}}|{{get:deviceinfo.d006.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_HOTWATER_TEMPERATURE}}|{{get:heatingCircuit.1.warmwassertemperatur.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_TANK_TEMPERATURE}}|{{get:heatingCircuit.1.speicher_ist_temperatur.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_DHW_FLOWRATE}}|{{get:deviceinfo.d036.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_CH_FLOWRATE}}|{{get:deviceinfo.d029.toString}}');
		// restförderhöhe
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_PRESSURE_HEAD}}|{{get:deviceinfo.d171.toString}}');
		//stellung 3-wege
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_3WAY_VALVE_POS}}|{{get:deviceinfo.d035.toString}}');
		elements.push('{{tr:DELIGHT_DATAOVERVIEW_ACTUAL_FAN_SPEED}}|{{get:deviceinfo.d034.toString}}');
		for (let element of elements) {
			let d = {
				"title": element,
				"type": "menuentry",
			};
			if (d.title.indexOf('DELIGHT_DATAOVERVIEW_PRESSURE_HEAD') != '-1') {
				d['id'] = "dataOverView.DELIGHT_DATAOVERVIEW_PRESSURE_HEAD";
			}
			nodes.push(new MenuNode(d));
		}
		return nodes;
	}

}